import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

const valuationOptions = {
    other: [
        { id: 1, name: 'Company Valuation', isChecked: false, value: "C" },
        { id: 2, name: 'Revenue Multiple', isChecked: false, value: "R" },
        { id: 3, name: 'EBITDA Multiple', isChecked: false, value: "E" },
        { id: 4, name: 'PAT Multiple', isChecked: false, value: "P" }
    ],
    maCompanies: [
        { id: 2, name: 'Revenue Multiple', isChecked: false, value: "R" },
        { id: 3, name: 'EBITDA Multiple', isChecked: false, value: "E" },
        { id: 4, name: 'PAT Multiple', isChecked: false, value: "P" }
    ]
};

/**
 * The `ValuationFilter` function is a React component that renders a filter for valuations with
 * options that can be selected or deselected.
 * @returns The `ValuationFilter` component is being returned.
 */
function ValuationFilter({ ValuationOptions, setValuationOptions, customPathname, dataPath = "other", label = "Valuations", isPopupOpen, setIsPopupOpen }) {
    const { refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.valuations?.map(value => value.id) ?? [];
        setValuationOptions(valuationOptions[dataPath]?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.id) })));
    }, [customPathname, refineSearchFilters, setValuationOptions, dataPath]);

    const handleValuationsChange = (e) => {
        const { name, checked, id, selectedEntities, filteredIds } = e.target;
        let updatedValuations;
    
        if (name === "allSelect") {
            updatedValuations = ValuationOptions.map(valuation => ({ ...valuation, isChecked: checked }));
        } else if (name === "filteredSelect" && filteredIds) {
            updatedValuations = ValuationOptions.map(valuation => ({
                ...valuation,
                isChecked: filteredIds.includes(parseInt(valuation.id)) ? checked : valuation.isChecked
            }));
        } else if (name === "selectedEntities" && selectedEntities) {
            const selectedEntityIds = selectedEntities.map(entity => parseInt(entity.id));
            updatedValuations = ValuationOptions.map(valuation => ({
                ...valuation,
                isChecked: selectedEntityIds.includes(valuation.id) ? !valuation.isChecked : valuation.isChecked
            }));
        } else {
            updatedValuations = ValuationOptions.map(valuation =>
                valuation.id === parseInt(id) ? { ...valuation, isChecked: checked } : valuation
            );
        }
    
        setValuationOptions(updatedValuations);
    };

    const selectedValuationCount = ValuationOptions?.filter(option => option.isChecked)?.length ?? 0;

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {ValuationOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedValuationCount > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedValuationCount}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)} label={label}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleValuationsChange}
                            primaryEntity={ValuationOptions}
                            searchBox={false}
                        />
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default ValuationFilter;
